import { CustomProductListEffects } from './custom-product-list.effect';

export const effects: any[] = [
    CustomProductListEffects
];
